var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/access.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-52cf98ba!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/access.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Access.vue
// module id = 603
// module chunks = 1